import validator from 'validator';
import {initPhoneNumber} from './intrernationalPhoneNumber';

/**
 * Resolves validator locale string for a country code (e.g. "IL" -> "he-IL").
 */
export function getPhoneValidationLocale(country) {
    return validator.isMobilePhoneLocales.find((locale) => locale.includes(country)) || 'he-IL';
}

/**
 * Returns E.164 digits without leading "+" from a national number and country, or "" if parsing fails.
 */
export function internationalDigitsFromNational(nationalNumber, country) {
    const parsed = initPhoneNumber({nationalNumber, country});
    if(parsed && typeof parsed === 'object' && 'internationalNumber' in parsed && parsed.internationalNumber != null) {
        return String(parsed.internationalNumber).replace(/^\+/, '');
    }
    return '';
}

/**
 * Same validation used across Yup `.phone` methods and CRM order phone change.
 */
export function isValidMobilePhoneNational(value, country) {
    if(!value) return false;
    const local = getPhoneValidationLocale(country);
    const digits = internationalDigitsFromNational(value, country);
    return validator.isMobilePhone(value, local) || (!!digits && validator.isMobilePhone(`+${digits}`, local));
}
